// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"presentations_wrapper__aMYyv","list":"presentations_list__E9jeu"};